import { Typography } from '@mui/material';

interface ErrorStackProps {
  stack: string;
}

export const ErrorStack = (props: ErrorStackProps) => (
  <>
    <Typography color='inherit' variant='h6'>
      Stack
    </Typography>
    <Typography
      color='inherit'
      component='pre'
      style={{
        maxHeight: 150,
        textAlign: 'left',
        overflow: 'auto',
      }}
    >
      {props.stack}
    </Typography>
  </>
);
